// important, keep this file vanilla es5 / commonjs because it will ONLY be babeld to Node 8,, NOT ii 11
module.exports = require('../../../../client/core-hooks/react/AppInit');
